import { inject, injectable } from 'inversify';
import type { ListenerInterface } from '@kiplin/web-common/event';
import { AppDependencyTypes } from '@shared/common/app/app.dependency-types';

@injectable()
export class AppPresenter {
  public constructor(
    @inject(AppDependencyTypes.AuthenticationRequiredNavigationListener)
    private readonly authenticationRequiredNavigationListener: ListenerInterface,
  ) {}

  public initialize(): void | Promise<void> {
    return this.authenticationRequiredNavigationListener.activate();
  }

  public destroy(): void | Promise<void> {
    return this.authenticationRequiredNavigationListener.deactivate();
  }
}
